/** DOC-5 / DOC-3 portal half (ANS-56): documents the provider shared with the client. */

export type ClientDocumentApproval = 'none' | 'pending' | 'approved' | 'rejected';

export interface ClientProjectDocument {
  id: string;
  title: string;
  category: string;
  direction: 'received' | 'sent' | 'internal' | string;
  received_on: string | null;
  description: string | null;
  updated_at: string;
  version_id: string | null;
  version_no: number | null;
  file_name: string | null;
  file_type: string | null;
  size: number;
  is_link: boolean;
  available: boolean;
  approval_status: ClientDocumentApproval;
  /** The provider asked this client to approve the current version. */
  awaiting_my_approval: boolean;
  decided_at: string | null;
  decided_by_client: boolean;
  client_decided_name: string | null;
  /**
   * Earlier versions this client may open (owner decision 2026-10-15): the versions they approved or rejected, or every
   * earlier version when the provider allows it. Older internal drafts are never listed.
   */
  earlier_versions?: number;
  /** Stream mlo (DOC-5 second half): the client uploaded it here ("Received from client"). */
  uploaded_by_client?: boolean;
}

/** Categories a client may pick for an upload (the provider can re-categorise it). */
export const CLIENT_UPLOAD_CATEGORIES = ['client_content', 'requirements', 'design', 'other'] as const;
export type ClientUploadCategory = (typeof CLIENT_UPLOAD_CATEGORIES)[number];

/** Same limits as the server (portal-upload-rules.ts). */
export const CLIENT_UPLOAD_MAX_BYTES = 10 * 1024 * 1024;
export const CLIENT_UPLOAD_EXTENSIONS = [
  'pdf', 'doc', 'docx', 'odt', 'rtf', 'txt', 'md', 'csv',
  'xls', 'xlsx', 'ods', 'ppt', 'pptx', 'odp',
  'png', 'jpg', 'jpeg', 'gif', 'webp', 'heic', 'heif',
  'zip',
] as const;

export interface ClientProjectDocuments {
  documents: ClientProjectDocument[];
  awaiting_approval: number;
}

export interface ClientDocumentVersion {
  id: string;
  version_no: number;
  is_current: boolean;
  uploaded_at: string;
  file_name: string | null;
  file_type: string | null;
  is_link: boolean;
  available: boolean;
  approval_status: ClientDocumentApproval;
  decided_at: string | null;
  decided_by_client: boolean;
  client_decided_name: string | null;
  client_comment: string | null;
}

export interface ClientProjectDocumentDetail {
  document: ClientProjectDocument;
  versions: ClientDocumentVersion[];
}

export interface ClientDocumentDownload {
  kind: 'file' | 'link';
  url: string;
  name: string | null;
}
